import React from 'react'
import MaterialSymbol from '../material-symbol'

const ChevronRight = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="chevron_right" {...props} />
))

ChevronRight.displayName = 'ChevronRight'

export default ChevronRight
